module.exports = __webpack_public_path__ + "static/media/east tower shot 01.64f0ddb1.webp";